@import "~@govbr-ds/core/src/components/list/list";
@import "~@govbr-ds/core/src/components/divider/divider";

:host {
  display: block;

  .br-list.horizontal ::slotted(br-item) {
    flex: 1;
    height: auto;
    min-height: 56px;
    width: auto;
  }
}
